import { render, staticRenderFns } from "./worngMessage.vue?vue&type=template&id=6be4a115&scoped=true&"
import script from "./worngMessage.vue?vue&type=script&lang=js&"
export * from "./worngMessage.vue?vue&type=script&lang=js&"
import style0 from "./worngMessage.vue?vue&type=style&index=0&id=6be4a115&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4a115",
  null
  
)

export default component.exports